"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTag = void 0;
/**
 * Format tag by removing unallowed characters
 */
const formatTag = (tag, 
// setting trim to false is useful when the user is typing the tag
trim = true) => {
    if (!tag)
        return tag;
    const formatted = tag.replace(/\s+/g, " ").replace(/,/g, "");
    return trim ? formatted.trim() : formatted;
};
exports.formatTag = formatTag;
//# sourceMappingURL=tag_helper.js.map